import Vue from 'vue';
import Vuex from 'vuex';
import LocalStorage from '../services/LocalStorage';

Vue.use(Vuex);

const localStorage = new LocalStorage();

export default new Vuex.Store({
  state: {
    currentId: '',
    holder: [],
    stamps: [
      { id: 's1', val: 1, img: 'stamp01.svg' },
      { id: 's2', val: 2, img: 'stamp02.svg' },
      { id: 's3', val: 3, img: 'stamp03.svg' },
      { id: 's4', val: 4, img: 'stamp04.svg' },
      { id: 's5', val: 5, img: 'stamp05.svg' },
      { id: 's6', val: 6, img: 'stamp06.svg' },
    ],
    showComplete: false,
  },
  mutations: {
    updateCurrentId(state, { id }) {
      state.currentId = id;
    },
    clearCurrentId(state) {
      state.currentId = '';
    },
    updateHolder(state, { holder }) {
      state.holder = holder;
    },
    clearHolder(state) {
      state.holder = [];
    },
    addHolder(state, { id }) {
      if (!state.holder.includes(id)) {
        state.holder.push(id);
      }
    },
    updateShowComplete(state, bool) {
      state.showComplete = bool;
    },
  },

  getters: {
    currentStamp(state) {
      return state.stamps.find((stamp) => stamp.id === state.currentId);
    },

    // 全スタンプがそろったか
    completed(state) {
      return state.holder.length === state.stamps.length;
    },
  },

  actions: {
    saveStamps({ state }) {
      localStorage.setStampHolder(state.holder);
    },
    loadStamps({ commit }) {
      const holder = localStorage.getStampHolder();
      if (holder) {
        commit('updateHolder', { holder });
      }
    },
    clearStamps({ commit }) {
      localStorage.removeStampHolder();
      commit('clearHolder');
    },
    addStamp({ state, commit, dispatch }, { id }) {
      if (state.stamps.find((stamp) => stamp.id === id)) {
        if (!state.holder.includes(id)) {
          commit('addHolder', { id });
          dispatch('saveStamps');
        }
      }
    },
  },
  modules: {
  },
});
